"use strict";

exports.__esModule = true;
exports.getBinName = exports.getBin = void 0;
var _timeAggregationBinMapping = require("./timeAggregationBinMapping");
var getBin = exports.getBin = function getBin(aggregateName, timeAggregationProps) {
  if (timeAggregationProps === void 0) {
    timeAggregationProps = {};
  }
  switch (aggregateName) {
    case "device":
      return {
        binName: "by_device",
        fieldName: "entity.device",
        aggType: "terms",
        options: {}
      };
    case "state":
      return {
        binName: "by_state",
        fieldName: "dimensions.state",
        aggType: "terms",
        options: {}
      };
    case "shift":
      return {
        binName: "by_shift",
        fieldName: "dimensions.shift",
        aggType: "terms",
        options: {}
      };
    default:
      return (0, _timeAggregationBinMapping.getTimeAggregationBin)(aggregateName, timeAggregationProps);
  }
};
var getBinName = exports.getBinName = function getBinName(aggregateName) {
  var _bin$binName;
  var bin = getBin(aggregateName);
  return (_bin$binName = bin == null ? void 0 : bin.binName) != null ? _bin$binName : "";
};